import { render, staticRenderFns } from "./R2s2traveler.vue?vue&type=template&id=01287c63&"
import script from "./R2s2traveler.vue?vue&type=script&lang=js&"
export * from "./R2s2traveler.vue?vue&type=script&lang=js&"
import style0 from "./R2s2traveler.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports